import React from 'react'
import ProductListContainer from 'containers/ProductList';

const ProductList = () => {
  return (
    <ProductListContainer />
  )
}

export default ProductList